<template>
  <div id="app">
    <AppHeader v-if="!loginKey" />
    <router-view />
    <AppFooter v-if="!loginKey" />
  </div>
</template>
<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

export default {
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      loginKey: false,
      tokenKey: false,
    }
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      this.tokenKey = sessionStorage.getItem('token')
      // 判断当前路由是否为 login
      const isLoginPage = to.path === '/login' || to.path === '/management'
      console.log('是否在登录页：', isLoginPage)

      // 可根据结果执行后续操作
      if (isLoginPage) {
        // 是登录页，执行逻辑
        this.loginKey = true
      } else {
        this.loginKey = false
        // 不是登录页，执行逻辑
      }
    }
  },
  // 初始化时也检查一次
  mounted() {
    const isLoginPage = this.$route.path === '/login'
    console.log('初始化时是否在登录页：', isLoginPage)
    if (isLoginPage) {
      // 是登录页，执行逻辑
      this.loginKey = true
    } else {
      this.loginKey = false
      // 不是登录页，执行逻辑
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  overflow-y: auto;
}

/* 响应式缩放控制 */
html {
  font-size: calc(100vw / 1920 * 16);
  /* 基于1920px设计稿的响应式基准 */
}

@media (max-width: 1600px) {
  html {
    font-size: calc(100vw / 1600 * 15);
  }
}

@media (max-width: 1366px) {
  html {
    font-size: calc(100vw / 1366 * 12.5);
  }
}

@media (max-width: 1024px) {
  html {
    font-size: calc(100vw / 1024 * 12);
  }
}
</style>
